(function () {
  var SECTION_SELECTOR = '.oddit-section-collection-tabs';

  function initSection(section) {
    var tabs = section.querySelectorAll('.oddit-section-collection-tabs__tab');
    var panels = section.querySelectorAll('.oddit-section-collection-tabs__panel');

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('oddit-section-collection-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('oddit-section-collection-tabs__panel--active');
          p.setAttribute('hidden', '');
        });
        tab.classList.add('oddit-section-collection-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');
        if (panels[index]) {
          panels[index].classList.add('oddit-section-collection-tabs__panel--active');
          panels[index].removeAttribute('hidden');
        }
      });

      tab.addEventListener('keydown', function (e) {
        var idx = Array.prototype.indexOf.call(tabs, e.target);
        var next;
        if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
